/**
 * Number Counter Block
 * Animates numbers from 0 to target value when they come into view,
 * with a slight zoom on each increment (same pattern as the reference).
 */

function countDecimals(raw) {
    const match = String(raw ?? '').match(/\.(\d+)/);
    return match ? match[1].length : 0;
}

function formatNumber(value, decimals) {
    if (decimals <= 0) {
        return String(Math.round(value));
    }

    return value.toFixed(decimals);
}

const ZOOM_DURATION_MS = 550;

function createZoomReplayer(counterElement) {
    let lastZoomAt = 0;

    return (force = false) => {
        const now = performance.now();

        if (!force && now - lastZoomAt < ZOOM_DURATION_MS) {
            return;
        }

        lastZoomAt = now;
        counterElement.style.animation = 'none';

        requestAnimationFrame(() => {
            counterElement.style.animation = '';
        });
    };
}

export function initNumberCounters() {
    const counterBlocks = document.querySelectorAll('.number-counter-block');

    if (counterBlocks.length === 0) return;

    counterBlocks.forEach(block => {
        const counterElement = block.querySelector('.set-number');

        if (!counterElement) return;

        if (counterElement.getAttribute('data-disable-animation') === '1') {
            return;
        }

        const targetRaw = counterElement.getAttribute('data-target');
        const incrementRaw = counterElement.getAttribute('data-increment');
        const targetNumber = parseFloat(targetRaw) || 0;
        const incrementNumber = parseFloat(incrementRaw) || 1;
        const decimals = Math.max(countDecimals(targetRaw), countDecimals(incrementRaw));

        let hasAnimated = false;
        const replayZoom = createZoomReplayer(counterElement);

        function animateCounter() {
            if (hasAnimated) return;
            hasAnimated = true;

            let currentNumber = 0;
            const duration = 2000;
            const totalSteps = Math.max(1, Math.ceil(targetNumber / incrementNumber));
            const stepDuration = duration / totalSteps;

            const counter = setInterval(() => {
                currentNumber += incrementNumber;
                const isComplete = currentNumber >= targetNumber;

                if (isComplete) {
                    currentNumber = targetNumber;
                    clearInterval(counter);
                }

                counterElement.textContent = formatNumber(currentNumber, decimals);
                replayZoom(isComplete);
            }, stepDuration);
        }

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    animateCounter();
                    observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.5 });

        observer.observe(counterElement);
    });
}

function boot() {
    initNumberCounters();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
} else {
    boot();
}
